import type { ReactNode } from "react";
import { EmptyCell } from "@/components/ui/empty-cell";

type Primitive = string | number | boolean | null | undefined;

export function displayValue(
	value: Primitive,
	options?: { unit?: string; fallback?: ReactNode },
): ReactNode {
	if (value === null || value === undefined || value === "") {
		return options?.fallback ?? <EmptyCell />;
	}
	return options?.unit ? `${value} ${options.unit}` : String(value);
}

export function displayDate(
	value: string | null | undefined,
	locale = "pl",
	options: Intl.DateTimeFormatOptions = {
		dateStyle: "short",
		timeStyle: "short",
	},
): ReactNode {
	if (!value) return <EmptyCell />;
	const d = new Date(value);
	if (Number.isNaN(d.getTime())) return <EmptyCell />;
	return new Intl.DateTimeFormat(locale, options).format(d);
}
